// extracted by mini-css-extract-plugin
export default {"dialog":"index-module--dialog--87c2f"};